var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"loading-container",attrs:{"fluid":"fluid","fill-height":"fill-height"}},[_c('v-layout',{staticClass:"loading-container",staticStyle:{"height":"300px"},attrs:{"justify-center":"justify-center","align-center":"align-center"}},[_c('loading-circle',{attrs:{"color":"rgba(0,0,0,0.36)"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }